module.exports = __webpack_public_path__ + "img/logo01.65e353b.jpg";